// File: src/pages/purchase/CreatePurchaseInvoice.jsx
import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Row,
  Form,
  Label,
  Button,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";
import Multiselect from "multiselect-react-dropdown";
import swal from "sweetalert";

import UserContext from "../import/context/Context";
import { PurchaseGstCalculation } from "../import/PurchaseGstCalculation";

import {
  CreateCustomerList,
  _Get,
  _PostSave,
} from "../import/ApiEndPoint/ApiCalling";
import {
  Purchase_Direct_Complete_Main,
  PurchaseProductList_Product,
  ViewOther_Charges,
  View_Customer_ById,
} from "../import/ApiEndPoint/Api";

/* ---------------- compact UI injection ---------------- */
const injectCompactCss = () => {
  const id = "cpi-compact-css";
  if (document.getElementById(id)) return;
  const s = document.createElement("style");
  s.id = id;
  s.textContent = `
  .cpi{ --fs:12px; --pad:6px; --gap:8px; --boxw: 92px; --labelfs:11px; }
  .cpi .card-body{ padding:10px; }
  .cpi label{ font-size: var(--labelfs); margin-bottom: 2px; font-weight: 600; }
  .cpi .form-control, .cpi .form-select{
    min-height: 30px; height: 30px; padding: 4px 8px; font-size: var(--fs); border-radius: 8px;
  }
  .cpi .btn{ --bs-btn-padding-y: 4px; --bs-btn-padding-x: 10px; font-size: 12px; line-height: 1.1; border-radius: 8px; }
  .cpi .btn-xxs{ padding: 2px 8px; font-size: 11px; }
  .cpi .headbar{ display:flex; align-items:center; justify-content:space-between; gap:10px; }
  .cpi .prod-row{ display:flex; align-items:end; gap:6px; flex-wrap:nowrap; overflow-x:auto; padding-bottom:2px; }
  .cpi .prod-row .box{ flex:0 0 auto; }
  .cpi .prod-select{ width: 240px; }
  .cpi .w-ware{ width:110px; } .cpi .w-hsn{ width:90px; }
  .cpi .w-gunit{ width:90px; } .cpi .w-gqty{ width:88px; }
  .cpi .w-nqty{ width:88px; } .cpi .w-nunit{ width:90px; }
  .cpi .w-tax{ width:70px; } .cpi .w-bprice{ width:110px; } .cpi .w-btotal{ width:120px; }
  .cpi .w-del{ width:50px; }

  .cpi .meta-adjust{
    display:grid;
    grid-template-columns: minmax(0, 1.65fr) minmax(280px, 0.75fr);
    gap:12px;
    align-items:start;
  }

  .cpi .meta-left{ min-width:0; }
  .cpi .bill-summary-only{ min-width:280px; }

  .cpi .meta-grid{
    display:grid; grid-template-columns: repeat(3, minmax(140px, 1fr)); gap:8px;
  }
  .cpi .meta-grid .box{ min-width: 140px; }

  .cpi .adjust-hsn-left{
    margin-top: 10px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px;
    background: #fff;
  }

  .cpi .adj-head, .cpi .adj-row{
    display:grid; grid-template-columns: 36px 86px 1fr 120px 80px 100px 100px 64px; gap:6px; align-items:end;
  }
  .cpi .adj-head{ font-weight:700; font-size:11px; margin-top:2px; margin-bottom:4px; }
  .cpi .jt-right-summary{ border:1px solid #e5e7eb; border-radius:10px; padding:10px; background:#fff; }
  .cpi .jt-right-summary ul{ list-style:none; margin:0; padding:0; }
  .cpi .jt-right-summary li{ display:flex; justify-content:space-between; padding:2px 0; font-size:12px; }
  .cpi .hr{ margin:6px 0; }
  .cpi .hsn-wrap{ margin-top:8px; }
  .cpi .hsn-wrap table{ font-size:12px; }
  .cpi .hsn-wrap th, .cpi .hsn-wrap td{ padding:4px 6px !important; }
  .cpi .top-controls{ display:flex; gap:10px; flex-wrap:wrap; align-items:end; }
  .cpi .top-controls .box{ min-width:220px; }
  .cpi h1{ font-size:18px; margin:0; }

  .cpi .batch-invoice-card{
    border:1px solid #dfe3e8; border-radius:12px; margin-bottom:10px; overflow:visible;
    box-shadow:0 2px 8px rgba(0,0,0,0.04);
  }
  .cpi .batch-card-header{
    display:flex; align-items:center; justify-content:space-between; gap:10px;
    padding:10px 12px; cursor:pointer; background:#f8f9fa; border-radius:12px;
  }
  .cpi .batch-card-header.active{ border-bottom-left-radius:0; border-bottom-right-radius:0; }
  .cpi .batch-card-title{ font-size:13px; font-weight:700; }
  .cpi .batch-card-subtitle{ font-size:11px; color:#6b7280; margin-top:2px; }
  .cpi .batch-card-actions{ display:flex; align-items:center; gap:6px; }
  .cpi .batch-card-body{ padding:10px; overflow:visible; }

  .cpi .multiselect-container,
  .cpi .multiSelectContainer{
    position: relative !important;
    background: #fff !important;
  }

  .cpi .multiselect-container .searchWrapper,
  .cpi .multiSelectContainer .searchWrapper{
    background: #fff !important;
    border: 1px solid #d1d5db !important;
    border-radius: 8px !important;
    min-height: 30px !important;
  }

  .cpi .multiselect-container .optionContainer,
  .cpi .multiSelectContainer .optionContainer{
    background: #fff !important;
    color: #111827 !important;
    border: 1px solid #d1d5db !important;
    border-radius: 8px !important;
    box-shadow: 0 14px 28px rgba(0,0,0,0.16) !important;
    z-index: 99999 !important;
    overflow-y: auto !important;
  }

  .cpi .multiselect-container .optionContainer ul,
  .cpi .multiselect-container .optionContainer li,
  .cpi .multiSelectContainer .optionContainer ul,
  .cpi .multiSelectContainer .optionContainer li{
    background: #fff !important;
    color: #111827 !important;
  }

  .cpi .multiselect-container .optionContainer li:hover,
  .cpi .multiSelectContainer .optionContainer li:hover{
    background: #f3f4f6 !important;
    color: #111827 !important;
  }

  .cpi .multiselect-container .highlight,
  .cpi .multiSelectContainer .highlight,
  .cpi .multiselect-container .highlightOption,
  .cpi .multiSelectContainer .highlightOption{
    background: #e5e7eb !important;
    color: #111827 !important;
  }

  .cpi .multiselect-container .chip,
  .cpi .multiSelectContainer .chip{
    background: #eef2ff !important;
    color: #111827 !important;
  }

  @media (max-width: 1200px){
    .cpi .meta-adjust{
      grid-template-columns: 1fr;
    }
    .cpi .bill-summary-only{
      min-width:0;
    }
  }
  `;
  document.head.appendChild(s);
};

/* ---------------- helpers ---------------- */
const round2 = (n) => Number((Number(n) || 0).toFixed(2));
const toNum = (v, d = 0) => {
  const num = Number(v);
  return Number.isFinite(num) ? num : d;
};
const parseGstPct = (g) => {
  if (g === null || g === undefined) return 0;
  if (typeof g === "number") return g || 0;
  const s = String(g).trim();
  if (!s) return 0;
  return s
    .split("+")
    .map((x) => Number(x) || 0)
    .reduce((a, b) => a + b, 0);
};
const sumLineBasics = (rows) =>
  (rows || []).reduce(
    (s, r) => s + Number(r?.qty || 0) * Number(r?.basicPrice || r?.price || 0),
    0,
  );
const roundHalfUp = (num) => {
  const frac = num - Math.floor(num);
  return frac > 0.49 ? Math.ceil(num) : Math.floor(num);
};
const safeJsonParse = (value, fallback) => {
  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const getFinancialYearLabel = (dateValue = new Date()) => {
  let year;
  let month;

  if (typeof dateValue === "string" && dateValue.includes("-")) {
    const [yyyy, mm] = dateValue.split("-");
    year = Number(yyyy);
    month = Number(mm);
  } else {
    const d = new Date(dateValue);
    year = d.getFullYear();
    month = d.getMonth() + 1;
  }

  if (!year || !month) {
    const d = new Date();
    year = d.getFullYear();
    month = d.getMonth() + 1;
  }

  const startYear = month >= 4 ? year : year - 1;
  const endYearShort = String(startYear + 1).slice(-2);

  return `${startYear}-${endYearShort}`;
};

const getFinancialYearRange = (financialYearSelected) => {
  const label = String(financialYearSelected || "").trim();
  const match = label.match(/^(\d{4})-(\d{2}|\d{4})$/);

  if (match) {
    const startYear = Number(match[1]);
    let endYear;

    if (match[2].length === 2) {
      endYear = Math.floor(startYear / 100) * 100 + Number(match[2]);
      if (endYear <= startYear) endYear += 100;
    } else {
      endYear = Number(match[2]);
    }

    return {
      minDate: `${startYear}-04-01`,
      maxDate: `${endYear}-03-31`,
    };
  }

  const fallbackFY = getFinancialYearLabel(new Date());
  const fallbackStart = Number(fallbackFY.split("-")[0]);

  return {
    minDate: `${fallbackStart}-04-01`,
    maxDate: `${fallbackStart + 1}-03-31`,
  };
};

const clampDateToRange = (dateValue, range) => {
  const value = String(dateValue || "");
  if (!value) return range.minDate;
  if (value < range.minDate) return range.minDate;
  if (value > range.maxDate) return range.maxDate;
  return value;
};

const isDateWithinRange = (dateValue, range) => {
  const value = String(dateValue || "");
  return !!value && value >= range.minDate && value <= range.maxDate;
};

const normalizeRow = (row = {}) => ({
  productId: row.productId || "",
  productData: row.productData || "",
  disCountPercentage: row.disCountPercentage ?? "",
  availableQty: row.availableQty ?? "",
  qty: row.qty ?? 1,
  price: row.price ?? "",
  Size: row.Size || "",
  unitType: row.unitType || "",
  unitPriceAfterDiscount: row.unitPriceAfterDiscount || "",
  taxableAmount: row.taxableAmount ?? 0,
  gstPercentage: row.gstPercentage ?? 0,
  sgstRate: row.sgstRate ?? 0,
  cgstRate: row.cgstRate ?? 0,
  igstRate: row.igstRate ?? 0,
  grandTotal: row.grandTotal ?? 0,
  warehouseName: row.warehouseName || "",
  HSN_Code: row.HSN_Code || "",
  secondaryUnit: row.secondaryUnit || "",
  GrossQty: row.GrossQty ?? 0,
  availQty: row.availQty ?? 0,
  primaryUnit: row.primaryUnit || "",
  basicPrice: row.basicPrice ?? 0,
  secondarySize: row.secondarySize ?? 1,
  landedCost: row.landedCost ?? 0,
});

const initialRow = {
  productId: "",
  productData: "",
  disCountPercentage: "",
  availableQty: "",
  qty: 1,
  price: "",
  Size: "",
  unitType: "",
  unitPriceAfterDiscount: "",
  taxableAmount: 0,
  gstPercentage: 0,
  sgstRate: 0,
  cgstRate: 0,
  igstRate: 0,
  grandTotal: 0,
  warehouseName: "",
  HSN_Code: "",
  secondaryUnit: "",
  GrossQty: 0,
  availQty: 0,
  primaryUnit: "",
  basicPrice: 0,
  secondarySize: 1,
  landedCost: 0,
};

const makeInvoiceSnapshot = ({
  defaultDate = "",
  partyLogin = false,
  partyId = "",
} = {}) => ({
  partyLogin,
  orderDate: defaultDate,
  partyId,
  party: {},
  rows: [{ ...initialRow }],
  GSTData: {},
  charges: 0,
  extra: {},
  landed: {},
  maxGst: {},
  selectedChargesRows: [],
  selectedDiscountRows: [],
  localRoundOff: 0,
  finalPrice: 0,
  taxRate: 0,
  finalPriceAfterTax: 0,
});

const buildHsnSummary = (
  items = [],
  discountRows = [],
  chargeRows = [],
  gstData = {},
) => {
  const isIGST = !!gstData?.Tax?.IgstTaxType;
  const byHSN = new Map();

  (items || []).forEach((r) => {
    const hsn = String(r?.HSN_Code || "NA");
    const ratePct = parseGstPct(r?.gstPercentage || 0);
    const basicTotal =
      Number(r?.qty || 0) * Number(r?.basicPrice || r?.price || 0);

    const g = byHSN.get(hsn) || {
      hsn,
      ratePct,
      basicTotal: 0,
      taxable: 0,
      cgst: 0,
      sgst: 0,
      igst: 0,
    };

    g.ratePct = ratePct;
    g.basicTotal += Number(basicTotal || 0);
    byHSN.set(hsn, g);
  });

  const totalDiscount = (discountRows || []).reduce(
    (a, x) => a + (Number(x?.__applied) || 0),
    0,
  );

  const grandBasicTotal = Array.from(byHSN.values()).reduce(
    (a, x) => a + Number(x.basicTotal || 0),
    0,
  );

  Array.from(byHSN.values()).forEach((g) => {
    const hsnDiscount =
      grandBasicTotal > 0
        ? (Number(g.basicTotal || 0) / grandBasicTotal) * totalDiscount
        : 0;

    const taxable = Number(g.basicTotal || 0) - Number(hsnDiscount || 0);
    g.taxable = round2(taxable < 0 ? 0 : taxable);

    const taxAmount = (g.taxable * Number(g.ratePct || 0)) / 100;

    if (isIGST) {
      g.igst = round2(taxAmount);
      g.cgst = 0;
      g.sgst = 0;
    } else {
      g.cgst = round2(taxAmount / 2);
      g.sgst = round2(taxAmount / 2);
      g.igst = 0;
    }
  });

  let maxRate = 0;
  for (const v of byHSN.values()) {
    maxRate = Math.max(maxRate, Number(v.ratePct || 0));
  }

  const chargesAmt = (chargeRows || []).reduce(
    (s, x) => s + (Number(x?.__applied) || 0),
    0,
  );
  const chargesTax = (chargesAmt * maxRate) / 100;

  const rowsOut = Array.from(byHSN.values())
    .map((r) => ({
      hsn: r.hsn,
      ratePct: r.ratePct,
      taxable: round2(r.taxable),
      cgst: round2(r.cgst),
      sgst: round2(r.sgst),
      igst: round2(r.igst),
      total: round2(r.taxable + r.cgst + r.sgst + r.igst),
    }))
    .sort((a, b) => b.ratePct - a.ratePct);

  if (chargesAmt > 0) {
    rowsOut.push({
      hsn: `CHARGES @ ${maxRate}%`,
      ratePct: maxRate,
      taxable: round2(chargesAmt),
      cgst: isIGST ? 0 : round2(chargesTax / 2),
      sgst: isIGST ? 0 : round2(chargesTax / 2),
      igst: isIGST ? round2(chargesTax) : 0,
      total: round2(chargesAmt + chargesTax),
    });
  }

  const totals = rowsOut.reduce(
    (acc, r) => ({
      taxable: acc.taxable + r.taxable,
      cgst: acc.cgst + (r.cgst || 0),
      sgst: acc.sgst + (r.sgst || 0),
      igst: acc.igst + (r.igst || 0),
      total: acc.total + r.total,
    }),
    { taxable: 0, cgst: 0, sgst: 0, igst: 0, total: 0 },
  );

  return { rows: rowsOut, totals, isIGST };
};

/* ---------------- Adjustments calculator ---------------- */
const computeAdjustments = (base = 0, discountsRows = [], chargesRows = []) => {
  let running = Number(base) || 0;
  const discApplied = [];
  const chgApplied = [];

  (discountsRows || []).forEach((r) => {
    const row = { ...r };
    const typ = (row?.discounttype || "").toLowerCase();
    if (typ === "percentage") {
      const val = (running * (Number(row?.percentage) || 0)) / 100;
      row.__applied = round2(Math.ceil(val * 100) / 100);
    } else {
      row.__applied = round2(Number(row?.amount) || 0);
    }
    running -= row.__applied;
    if (running < 0) running = 0;
    discApplied.push(row);
  });

  (chargesRows || []).forEach((r) => {
    const row = { ...r };
    const typ = (row?.discounttype || "").toLowerCase();
    if (typ === "percentage") {
      const val = (running * (Number(row?.percentage) || 0)) / 100;
      row.__applied = round2(val);
    } else {
      row.__applied = round2(Number(row?.amount) || 0);
    }
    running += row.__applied;
    chgApplied.push(row);
  });

  const discountTotal = round2(
    discApplied.reduce((a, x) => a + (x.__applied || 0), 0),
  );
  const chargesTotal = round2(
    chgApplied.reduce((a, x) => a + (x.__applied || 0), 0),
  );

  return {
    discountTotal,
    chargesTotal,
    discountRowsApplied: discApplied,
    chargeRowsApplied: chgApplied,
    netAfterAdj: round2(running),
  };
};

const CreatePurchaseInvoice = (args) => {
  const navigate = useNavigate();
  const Context = useContext(UserContext);

  useEffect(() => injectCompactCss(), []);

  const user = safeJsonParse(localStorage.getItem("userData") || "{}", {});
  const financialYearSelected = localStorage.getItem("financialYearSelected");
  const financialYearRange = useMemo(
    () => getFinancialYearRange(financialYearSelected),
    [financialYearSelected],
  );
  const todayString = useMemo(() => {
    const today = new Date();
    return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(
      today.getDate(),
    ).padStart(2, "0")}`;
  }, []);
  const defaultFinancialDate = clampDateToRange(
    todayString,
    financialYearRange,
  );

  const draftKey = useMemo(() => {
    const db = user?.database || "defaultdb";
    const uid = user?._id || "defaultuser";
    return `CREATE_PURCHASE_INVOICE_DRAFT_${db}_${uid}`;
  }, [user?.database, user?._id]);

  const [loading, setLoading] = useState(false);
  const [partyLogin, setPartyLogin] = useState(false);
  const [orderDate, setOrderDate] = useState("");
  const [modal, setModal] = useState(false);

  const [partyList, setPartyList] = useState([]);
  const [productList, setProductList] = useState([]);

  const [partyId, setPartyId] = useState("");
  const [party, setParty] = useState({});

  const [rows, setRows] = useState([{ ...initialRow }]);

  const [GSTData, setGSTData] = useState({});
  const [charges, setCharges] = useState(0);
  const [extra, setExtra] = useState({});
  const [landed, setLanded] = useState({});
  const [maxGst, setMaxGst] = useState({});

  const [chargesMaster, setChargesMaster] = useState([]);
  const [selectedChargesRows, setSelectedChargesRows] = useState([]);
  const [selectedDiscountRows, setSelectedDiscountRows] = useState([]);
  const [localRoundOff, setLocalRoundOff] = useState(0);
  const [finalPrice, setFinalPrice] = useState(0);
  const [taxRate, setTaxRate] = useState(0);
  const [finalPriceAfterTax, setFinalPriceAfterTax] = useState(0);

  const multiselectRefs = useRef(rows.map(() => React.createRef()));
  const [didHydrateDraft, setDidHydrateDraft] = useState(false);
  const [invoiceForms, setInvoiceForms] = useState(() => [
    makeInvoiceSnapshot({
      defaultDate: defaultFinancialDate,
      partyLogin: user?.rolename?.roleName === "Customer",
      partyId: user?.rolename?.roleName === "Customer" ? user?._id || "" : "",
    }),
  ]);
  const [activeFormIndex, setActiveFormIndex] = useState(0);

  const getCurrentFormSnapshot = () => ({
    partyLogin,
    orderDate,
    partyId,
    party,
    rows: (rows || []).map(normalizeRow),
    GSTData,
    charges,
    extra,
    landed,
    maxGst,
    selectedChargesRows,
    selectedDiscountRows,
    localRoundOff,
    finalPrice,
    taxRate,
    finalPriceAfterTax,
  });

  const applyFormSnapshot = (snapshot = {}) => {
    const nextRows =
      Array.isArray(snapshot?.rows) && snapshot.rows.length
        ? snapshot.rows.map(normalizeRow)
        : [{ ...initialRow }];

    const nextExtra = { ...(snapshot?.extra || {}) };
    if (
      nextExtra.DispatchDate &&
      !isDateWithinRange(nextExtra.DispatchDate, financialYearRange)
    ) {
      nextExtra.DispatchDate = "";
    }

    setPartyLogin(!!snapshot?.partyLogin);
    setOrderDate(
      clampDateToRange(
        snapshot?.orderDate || defaultFinancialDate,
        financialYearRange,
      ),
    );
    setPartyId(snapshot?.partyId || "");
    setParty(snapshot?.party || {});
    setRows(nextRows);
    setGSTData(snapshot?.GSTData || {});
    setCharges(Number(snapshot?.charges || 0));
    setExtra(nextExtra);
    setLanded(snapshot?.landed || {});
    setMaxGst(snapshot?.maxGst || {});
    setSelectedChargesRows(snapshot?.selectedChargesRows || []);
    setSelectedDiscountRows(snapshot?.selectedDiscountRows || []);
    setLocalRoundOff(Number(snapshot?.localRoundOff || 0));
    setFinalPrice(Number(snapshot?.finalPrice || 0));
    setTaxRate(Number(snapshot?.taxRate || 0));
    setFinalPriceAfterTax(Number(snapshot?.finalPriceAfterTax || 0));

    multiselectRefs.current = Array.from({ length: nextRows.length }, () =>
      React.createRef(),
    );
  };

  const recalcGST = (partyObj, items, chg) => {
    const g = PurchaseGstCalculation(partyObj, items, Context, chg);
    setGSTData(g);
    return g;
  };

  const recalcTotals = (
    _rows = rows,
    _discountRows = selectedDiscountRows,
    _chargeRows = selectedChargesRows,
    _party = party,
    gstSnapshot = null,
  ) => {
    const basicTotal = sumLineBasics(_rows);

    const {
      chargesTotal,
      discountRowsApplied,
      chargeRowsApplied,
      netAfterAdj,
    } = computeAdjustments(basicTotal, _discountRows, _chargeRows);

    setSelectedDiscountRows(discountRowsApplied);
    setSelectedChargesRows(chargeRowsApplied);

    const gst = gstSnapshot || GSTData;
    const isIGST = !!gst?.Tax?.IgstTaxType;

    const maxItemGST =
      _rows.reduce(
        (m, p) => Math.max(m, Number(parseGstPct(p?.gstPercentage || 0))),
        0,
      ) || 0;

    const chargesGST = (chargesTotal * maxItemGST) / 100;
    const half = chargesGST / 2;

    let addIGST = 0,
      addCGST = 0,
      addSGST = 0;
    if (isIGST) addIGST = chargesGST;
    else {
      addCGST = half;
      addSGST = half;
    }

    setFinalPrice(Number(netAfterAdj).toFixed(2));
    setTaxRate(Number(addIGST + addCGST + addSGST));

    const hsnBasedTotals = (() => {
      const grouped = new Map();

      (_rows || []).forEach((r) => {
        const hsn = String(r?.HSN_Code || "NA");
        const ratePct = parseGstPct(r?.gstPercentage || 0);
        const basicTotalRow =
          Number(r?.qty || 0) * Number(r?.basicPrice || r?.price || 0);

        const g = grouped.get(hsn) || {
          hsn,
          ratePct,
          basicTotal: 0,
        };

        g.ratePct = ratePct;
        g.basicTotal += Number(basicTotalRow || 0);
        grouped.set(hsn, g);
      });

      const totalDiscount = (_discountRows || []).reduce(
        (a, x) => a + (Number(x?.__applied) || 0),
        0,
      );

      const grandBasic = Array.from(grouped.values()).reduce(
        (a, x) => a + Number(x.basicTotal || 0),
        0,
      );

      let taxableTotal = 0;
      let taxTotal = 0;

      Array.from(grouped.values()).forEach((g) => {
        const proportionalDiscount =
          grandBasic > 0
            ? (Number(g.basicTotal || 0) / grandBasic) * totalDiscount
            : 0;

        const taxable = Math.max(
          0,
          Number(g.basicTotal || 0) - Number(proportionalDiscount || 0),
        );

        taxableTotal += taxable;
        taxTotal += (taxable * Number(g.ratePct || 0)) / 100;
      });

      taxTotal += Number(addIGST + addCGST + addSGST || 0);
      taxableTotal += Number(chargesTotal || 0);

      return {
        taxableTotal: round2(taxableTotal),
        taxTotal: round2(taxTotal),
        gross: round2(taxableTotal + taxTotal),
      };
    })();

    const rounded = roundHalfUp(hsnBasedTotals.gross);
    const roundOff = round2(rounded - hsnBasedTotals.gross);

    setFinalPrice(hsnBasedTotals.taxableTotal);
    setLocalRoundOff(roundOff);
    setFinalPriceAfterTax(rounded);
  };

  useEffect(() => {
    const draft = safeJsonParse(localStorage.getItem(draftKey) || "null", null);

    let formsToLoad;
    let initialActiveIndex = 0;

    if (Array.isArray(draft?.invoiceForms) && draft.invoiceForms.length) {
      formsToLoad = draft.invoiceForms.map((form) => ({
        ...form,
        orderDate: clampDateToRange(
          form?.orderDate || defaultFinancialDate,
          financialYearRange,
        ),
        rows:
          Array.isArray(form?.rows) && form.rows.length
            ? form.rows.map(normalizeRow)
            : [{ ...initialRow }],
        extra: {
          ...(form?.extra || {}),
          DispatchDate:
            form?.extra?.DispatchDate &&
            isDateWithinRange(form.extra.DispatchDate, financialYearRange)
              ? form.extra.DispatchDate
              : "",
        },
      }));

      initialActiveIndex = Math.min(
        Math.max(Number(draft?.activeFormIndex || 0), 0),
        formsToLoad.length - 1,
      );
    } else if (draft) {
      formsToLoad = [
        {
          ...draft,
          orderDate: clampDateToRange(
            draft?.orderDate || defaultFinancialDate,
            financialYearRange,
          ),
          rows:
            Array.isArray(draft?.rows) && draft.rows.length
              ? draft.rows.map(normalizeRow)
              : [{ ...initialRow }],
          extra: {
            ...(draft?.extra || {}),
            DispatchDate:
              draft?.extra?.DispatchDate &&
              isDateWithinRange(draft.extra.DispatchDate, financialYearRange)
                ? draft.extra.DispatchDate
                : "",
          },
        },
      ];
    } else {
      formsToLoad = [
        makeInvoiceSnapshot({
          defaultDate: defaultFinancialDate,
          partyLogin: user?.rolename?.roleName === "Customer",
          partyId:
            user?.rolename?.roleName === "Customer" ? user?._id || "" : "",
        }),
      ];
    }

    setInvoiceForms(formsToLoad);
    setActiveFormIndex(initialActiveIndex);
    applyFormSnapshot(formsToLoad[initialActiveIndex]);

    _Get(PurchaseProductList_Product, user?.database)
      .then((res) => {
        const list = (res?.Product || []).map((p) => ({
          ...p,
          value: p?._id,
          label: p?.Product_Title,
        }));
        setProductList(list);
      })
      .catch(() => {});

    CreateCustomerList(user?._id, user?.database)
      .then((res) => setPartyList(res?.Customer || []))
      .catch(() => {});

    if (user?.database) {
      _Get(ViewOther_Charges, user.database)
        .then((res) => setChargesMaster(res?.OtherCharges || []))
        .catch(() => setChargesMaster([]));
    }

    setDidHydrateDraft(true);
  }, [draftKey]);

  useEffect(() => {
    if (multiselectRefs.current.length < rows.length) {
      for (let i = multiselectRefs.current.length; i < rows.length; i++) {
        multiselectRefs.current.push(React.createRef());
      }
    } else if (multiselectRefs.current.length > rows.length) {
      multiselectRefs.current = multiselectRefs.current.slice(0, rows.length);
    }
  }, [rows.length]);

  useEffect(() => {
    if (!didHydrateDraft) return;

    const currentSnapshot = getCurrentFormSnapshot();

    setInvoiceForms((prev) => {
      const nextForms = prev.length ? [...prev] : [currentSnapshot];
      nextForms[activeFormIndex] = currentSnapshot;

      localStorage.setItem(
        draftKey,
        JSON.stringify({
          invoiceForms: nextForms,
          activeFormIndex,
        }),
      );

      return nextForms;
    });
  }, [
    didHydrateDraft,
    draftKey,
    activeFormIndex,
    partyLogin,
    orderDate,
    partyId,
    party,
    rows,
    GSTData,
    charges,
    extra,
    landed,
    maxGst,
    selectedChargesRows,
    selectedDiscountRows,
    localRoundOff,
    finalPrice,
    taxRate,
    finalPriceAfterTax,
  ]);

  const hsnSummary = useMemo(
    () =>
      buildHsnSummary(rows, selectedDiscountRows, selectedChargesRows, GSTData),
    [rows, selectedDiscountRows, selectedChargesRows, GSTData],
  );

  const summaryFromHSN = {
    taxable: round2(hsnSummary?.totals?.taxable || 0),
    igst: round2(hsnSummary?.totals?.igst || 0),
    cgst: round2(hsnSummary?.totals?.cgst || 0),
    sgst: round2(hsnSummary?.totals?.sgst || 0),
    gross: round2(hsnSummary?.totals?.total || 0),
  };

  const summaryRoundedGrandTotal = roundHalfUp(summaryFromHSN.gross);
  const summaryRoundOff = round2(
    summaryRoundedGrandTotal - summaryFromHSN.gross,
  );

  const grandTotalMismatch =
    Number(finalPriceAfterTax || 0) !== Number(summaryRoundedGrandTotal || 0);

  const billTaxSummary = {
    isIGST: !!hsnSummary?.isIGST,
    igst: round2(hsnSummary?.totals?.igst || 0),
    cgst: round2(hsnSummary?.totals?.cgst || 0),
    sgst: round2(hsnSummary?.totals?.sgst || 0),
  };

  const hsnTaxSummary = {
    igst: round2(hsnSummary?.totals?.igst || 0),
    cgst: round2(hsnSummary?.totals?.cgst || 0),
    sgst: round2(hsnSummary?.totals?.sgst || 0),
  };

  const taxMismatch = {
    igst: round2(billTaxSummary.igst - hsnTaxSummary.igst),
    cgst: round2(billTaxSummary.cgst - hsnTaxSummary.cgst),
    sgst: round2(billTaxSummary.sgst - hsnTaxSummary.sgst),
  };

  const fetchFullPartyById = async (customerId) => {
    try {
      const res = await _Get(`${View_Customer_ById}${customerId}`, "");
      console.log("customer selected: ", res);
      return res?.Customer;
    } catch (err) {
      return {};
    }
  };

  const handleSelectParty = async (selectedList, selected) => {
    const selectedId = selected?._id;
    if (!selectedId) return;

    const fullParty = await fetchFullPartyById(selectedId);
    const finalParty = fullParty?._id ? fullParty : selected;

    setPartyId(selectedId);
    setParty(finalParty);

    const g = recalcGST(finalParty, rows, charges);

    const next = rows.map((r, i) => ({
      ...r,
      taxableAmount:
        r.taxableAmount !== "" &&
        r.taxableAmount !== null &&
        r.taxableAmount !== undefined
          ? r.taxableAmount
          : (g?.gstDetails?.[i]?.taxable ?? r.taxableAmount),
      sgstRate: g?.gstDetails?.[i]?.sgstRate ?? r.sgstRate,
      cgstRate: g?.gstDetails?.[i]?.cgstRate ?? r.cgstRate,
      igstRate: g?.gstDetails?.[i]?.igstRate ?? r.igstRate,
      grandTotal: g?.gstDetails?.[i]?.grandTotal ?? r.grandTotal,
      gstPercentage: g?.gstDetails?.[i]?.gstPercentage ?? r.gstPercentage,
      disCountPercentage:
        g?.gstDetails?.[i]?.discountPercentage ?? r.disCountPercentage,
    }));

    setRows(next);
    recalcTotals(
      next,
      selectedDiscountRows,
      selectedChargesRows,
      finalParty,
      g,
    );
  };

  const handleRemoveParty = () => {
    setPartyId("");
    setParty({});
    setGSTData({});
    multiselectRefs.current.forEach((ref) =>
      ref?.current?.resetSelectedValues?.(),
    );
    setRows([{ ...initialRow }]);
    setSelectedChargesRows([]);
    setSelectedDiscountRows([]);
    setFinalPrice(0);
    setTaxRate(0);
    setFinalPriceAfterTax(0);
    setLocalRoundOff(0);
  };

  const handleSelectProduct = (_list, item, idx) => {
    const userDisc = Number(
      party?.Category?.discount || party?.category?.discount || 0,
    );
    const costPrice = Number(
      (
        (item?.Product_MRP || 0) /
        (((100 + userDisc) / 100) * ((100 + Number(item?.GSTRate || 0)) / 100))
      ).toFixed(2),
    );

    setRows((prev) => {
      const next = [...prev];
      const r = { ...next[idx] };

      r.productId = item?._id;
      r.productData = item;
      r.warehouseName = item?.warehouse?.warehouseName || "";
      r.HSN_Code = item?.HSN_Code || "";
      r.primaryUnit = item?.primaryUnit || "";
      r.secondaryUnit = item?.secondaryUnit || "";
      r.secondarySize = Number(item?.secondarySize || 1);
      r.GrossQty = Number((1 / (r.secondarySize || 1)).toFixed(3));
      r.qty = 1;
      r.gstPercentage = item?.GSTRate || 0;
      r.disCountPercentage = userDisc || 0;
      r.basicPrice = costPrice;
      r.price = costPrice;
      r.taxableAmount = Number(
        (Number(r.qty || 0) * Number(costPrice || 0)).toFixed(2),
      );

      next[idx] = r;

      const g = recalcGST(party, next, charges);
      const gi = g?.gstDetails?.[idx] || {};
      next[idx] = {
        ...next[idx],
        sgstRate: gi.sgstRate ?? 0,
        cgstRate: gi.cgstRate ?? 0,
        igstRate: gi.igstRate ?? 0,
        grandTotal: gi.grandTotal ?? 0,
        gstPercentage: gi.gstPercentage ?? next[idx].gstPercentage,
        disCountPercentage:
          gi.discountPercentage ?? next[idx].disCountPercentage,
      };

      recalcTotals(next, selectedDiscountRows, selectedChargesRows, party, g);
      return next;
    });
  };

  const handleRemoveProduct = (_list, _item, idx) => {
    setRows((prev) => {
      const next = [...prev];
      next[idx] = { ...initialRow };
      const g = recalcGST(party, next, charges);
      recalcTotals(next, selectedDiscountRows, selectedChargesRows, party, g);
      return next;
    });
  };

  const handleQtyChange = (e, idx) => {
    const { name, value } = e.target;
    const v = value === "" ? "" : Number(value);

    setRows((prev) => {
      const next = [...prev];
      const n = { ...next[idx] };
      const secondarySize = toNum(n.secondarySize, 1);

      if (name === "GrossQty") {
        n.GrossQty = v === "" ? "" : v;
        n.qty = v === "" ? "" : Number((secondarySize * v).toFixed(3));
      } else if (name === "qty") {
        n.qty = v === "" ? "" : v;
        n.GrossQty =
          v === "" ? "" : Number((v / (secondarySize || 1)).toFixed(3));
      }

      n.taxableAmount =
        n.qty === "" || n.basicPrice === ""
          ? ""
          : Number((Number(n.qty || 0) * Number(n.basicPrice || 0)).toFixed(2));

      next[idx] = n;

      const gstReadyRows = next.map((row) => ({
        ...row,
        qty: row.qty === "" ? 0 : Number(row.qty || 0),
        GrossQty: row.GrossQty === "" ? 0 : Number(row.GrossQty || 0),
      }));

      const g = recalcGST(party, gstReadyRows, charges);
      const gi = g?.gstDetails?.[idx] || {};
      next[idx] = {
        ...next[idx],
        sgstRate: gi.sgstRate ?? 0,
        cgstRate: gi.cgstRate ?? 0,
        igstRate: gi.igstRate ?? 0,
        grandTotal: gi.grandTotal ?? 0,
        gstPercentage: gi.gstPercentage ?? next[idx].gstPercentage,
        disCountPercentage:
          gi.discountPercentage ?? next[idx].disCountPercentage,
      };

      recalcTotals(next, selectedDiscountRows, selectedChargesRows, party, g);
      return next;
    });
  };

  const handlePriceChange = (e, idx) => {
    const value = e.target.value;
    const v = value === "" ? "" : Number(value);

    setRows((prev) => {
      const next = [...prev];
      const qty = Number(next[idx]?.qty || 0);

      next[idx] = {
        ...next[idx],
        basicPrice: v,
        price: v,
        taxableAmount:
          v === "" ? "" : Number((qty * Number(v || 0)).toFixed(2)),
      };

      return next;
    });
  };

  const handleBasicTotalChange = (e, idx) => {
    const value = e.target.value;

    setRows((prev) => {
      const next = [...prev];
      const currentRow = { ...next[idx] };
      const qty = Number(currentRow.qty || 0);

      if (value === "") {
        currentRow.taxableAmount = "";
        currentRow.basicPrice = "";
        currentRow.price = "";
        next[idx] = currentRow;
        return next;
      }

      const enteredTotal = Number(value);
      if (!Number.isFinite(enteredTotal)) return prev;

      const newBasicPrice = qty > 0 ? enteredTotal / qty : 0;

      currentRow.taxableAmount = value;
      currentRow.basicPrice = Number(newBasicPrice.toFixed(6));
      currentRow.price = Number(newBasicPrice.toFixed(6));

      next[idx] = currentRow;
      return next;
    });
  };

  const addRow = () => {
    multiselectRefs.current.push(React.createRef());
    setRows((p) => [...p, { ...initialRow }]);
  };

  const removeRow = (i) =>
    setRows((p) => {
      const n = [...p];
      n.splice(i, 1);
      const finalRows = n.length ? n : [{ ...initialRow }];
      const g = recalcGST(party, finalRows, charges);
      recalcTotals(
        finalRows,
        selectedDiscountRows,
        selectedChargesRows,
        party,
        g,
      );
      return finalRows;
    });

  const handleCharges = (e) => {
    const v = Number(e.target.value || 0);
    setCharges(v);
    const g = recalcGST(party, rows, v);
    recalcTotals(rows, selectedDiscountRows, selectedChargesRows, party, g);
  };

  const openUpdateModal = (e) => {
    e.preventDefault();

    const normalized = rows.map((r) => {
      let gp = r.gstPercentage;
      if (typeof gp !== "number") {
        gp = String(gp || "").includes("+")
          ? Number(String(gp).split("+")[0]) * 2
          : Number(gp || 0);
      }
      return { ...r, gstPercentage: gp };
    });

    setRows(normalized);
    setMaxGst(
      normalized.reduce((prev, curr) =>
        (prev?.gstPercentage || 0) > (curr?.gstPercentage || 0) ? prev : curr,
      ),
    );
    setRows((p) => p.map((r) => ({ ...r, landedCost: r.basicPrice })));

    const g = recalcGST(party, normalized, charges);
    recalcTotals(
      normalized,
      selectedDiscountRows,
      selectedChargesRows,
      party,
      g,
    );
    setModal(true);
  };

  const handleLanded = (e) => {
    const { name, value } = e.target;
    const update = { ...landed, [name]: Number(value || 0) };

    const sum =
      (update.transportationCost || 0) +
      (update.MiscellanousCost || 0) +
      (update.LocalFreight || 0) +
      (update.LabourCost || 0);

    const landedTax = Number(
      ((sum * (maxGst?.gstPercentage || 0)) / 100).toFixed(2),
    );
    update.landedTax = landedTax;
    setLanded(update);

    const base = Number(GSTData?.Tax?.Amount || 0);
    const totalExpenses = sum + landedTax;
    const upliftPct = base > 0 ? (totalExpenses / base) * 100 : 0;

    setRows((prev) =>
      prev.map((r) => ({
        ...r,
        landedCost: Number(
          ((Number(r.basicPrice || 0) * (100 + upliftPct)) / 100).toFixed(2),
        ),
      })),
    );
  };

  const clearDraft = () => {
    localStorage.removeItem(draftKey);
  };

  const saveLandedPriceForCurrentInvoice = () => {
    const currentSnapshot = getCurrentFormSnapshot();
    const nextForms = invoiceForms.length ? [...invoiceForms] : [];
    nextForms[activeFormIndex] = currentSnapshot;
    setInvoiceForms(nextForms);
    setModal(false);
  };

  const switchInvoiceForm = (index) => {
    if (
      index === activeFormIndex ||
      index < 0 ||
      index >= invoiceForms.length
    ) {
      return;
    }

    const currentSnapshot = getCurrentFormSnapshot();
    const nextForms = [...invoiceForms];
    nextForms[activeFormIndex] = currentSnapshot;

    setInvoiceForms(nextForms);
    setActiveFormIndex(index);
    applyFormSnapshot(nextForms[index]);
    setModal(false);
  };

  const addMoreInvoiceForm = () => {
    const currentSnapshot = getCurrentFormSnapshot();
    const blankForm = makeInvoiceSnapshot({
      defaultDate: defaultFinancialDate,
      partyLogin: user?.rolename?.roleName === "Customer",
      partyId: user?.rolename?.roleName === "Customer" ? user?._id || "" : "",
    });

    const nextForms = invoiceForms.length ? [...invoiceForms] : [];
    nextForms[activeFormIndex] = currentSnapshot;
    nextForms.push(blankForm);

    const nextIndex = nextForms.length - 1;
    setInvoiceForms(nextForms);
    setActiveFormIndex(nextIndex);
    applyFormSnapshot(blankForm);
    setModal(false);
  };

  const removeInvoiceForm = (index) => {
    if (invoiceForms.length <= 1) return;

    const currentSnapshot = getCurrentFormSnapshot();
    const nextForms = [...invoiceForms];
    nextForms[activeFormIndex] = currentSnapshot;
    nextForms.splice(index, 1);

    if (index === activeFormIndex) {
      const nextActiveIndex = Math.max(0, index - 1);
      setInvoiceForms(nextForms);
      setActiveFormIndex(nextActiveIndex);
      applyFormSnapshot(nextForms[nextActiveIndex]);
    } else {
      const nextActiveIndex =
        index < activeFormIndex ? activeFormIndex - 1 : activeFormIndex;
      setInvoiceForms(nextForms);
      setActiveFormIndex(nextActiveIndex);
    }

    setModal(false);
  };

  useEffect(() => {
    const syncRestoredParty = async () => {
      if (!partyId) return;

      const fullParty = await fetchFullPartyById(partyId);
      if (!fullParty?._id) return;

      setParty(fullParty);

      const g = recalcGST(fullParty, rows, charges);
      recalcTotals(
        rows,
        selectedDiscountRows,
        selectedChargesRows,
        fullParty,
        g,
      );
    };

    if (didHydrateDraft && partyId) {
      syncRestoredParty();
    }
  }, [didHydrateDraft, partyId]);

  const submitFinal = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const currentSnapshot = getCurrentFormSnapshot();
      const formsToSave = invoiceForms.length ? [...invoiceForms] : [];
      formsToSave[activeFormIndex] = currentSnapshot;

      const selectedDatabase = `${user?.database}-${financialYearSelected}`;
      const payloads = [];

      for (let formIndex = 0; formIndex < formsToSave.length; formIndex++) {
        const form = formsToSave[formIndex] || {};
        const formNumber = formIndex + 1;
        const formRows =
          Array.isArray(form?.rows) && form.rows.length
            ? form.rows.map(normalizeRow)
            : [{ ...initialRow }];
        const formParty = form?.party || {};
        const formPartyId = form?.partyId || "";
        const formOrderDate = form?.orderDate || "";
        const formCharges = Number(form?.charges || 0);
        const formExtra = form?.extra || {};
        const formLanded = form?.landed || {};

        if (!formPartyId) {
          throw new Error(`Choose Party in Purchase Invoice ${formNumber}`);
        }

        if (!isDateWithinRange(formOrderDate, financialYearRange)) {
          throw new Error(
            `Invoice Date in Purchase Invoice ${formNumber} must be between ${financialYearRange.minDate} and ${financialYearRange.maxDate}`,
          );
        }

        if (
          formExtra?.DispatchDate &&
          !isDateWithinRange(formExtra.DispatchDate, financialYearRange)
        ) {
          throw new Error(
            `Dispatch Date in Purchase Invoice ${formNumber} must be between ${financialYearRange.minDate} and ${financialYearRange.maxDate}`,
          );
        }

        const purchaseOrderNumber = String(formExtra?.invoiceId || "").trim();
        if (!purchaseOrderNumber) {
          throw new Error(
            `Invoice Number is required in Purchase Invoice ${formNumber}`,
          );
        }

        if (!String(formExtra?.BuiltyNumber || "").trim()) {
          throw new Error(
            `Builty Number is required in Purchase Invoice ${formNumber}`,
          );
        }

        if (!String(formExtra?.DispatchDate || "").trim()) {
          throw new Error(
            `Dispatch Date is required in Purchase Invoice ${formNumber}`,
          );
        }

        if (
          formExtra?.NoOfPackage === "" ||
          formExtra?.NoOfPackage === null ||
          formExtra?.NoOfPackage === undefined
        ) {
          throw new Error(
            `No of Packages is required in Purchase Invoice ${formNumber}`,
          );
        }

        if (!String(formExtra?.vehicleNo || "").trim()) {
          throw new Error(
            `Vehicle Number is required in Purchase Invoice ${formNumber}`,
          );
        }

        if (!formRows.some((item) => item?.productId)) {
          throw new Error(
            `Choose at least one Product in Purchase Invoice ${formNumber}`,
          );
        }

        const g = PurchaseGstCalculation(
          formParty,
          formRows,
          Context,
          formCharges,
        );

        const basicTotal = sumLineBasics(formRows);
        const { chargesTotal, discountRowsApplied, chargeRowsApplied } =
          computeAdjustments(
            basicTotal,
            form?.selectedDiscountRows || [],
            form?.selectedChargesRows || [],
          );

        const igstTaxType = !!g?.Tax?.IgstTaxType;

        const highestGstPct = (() => {
          let maxPct = 0;
          (formRows || []).forEach((p) => {
            const gp = parseGstPct(p?.gstPercentage);
            if (!isNaN(gp) && gp > maxPct) maxPct = gp;
          });
          (g?.gstDetails || []).forEach((row) => {
            const gp = parseGstPct(row?.gstPercentage);
            if (!isNaN(gp) && gp > maxPct) maxPct = gp;
          });
          return maxPct || 0;
        })();

        let chargesCgst = 0;
        let chargesSgst = 0;
        let chargesIgst = 0;

        if (chargesTotal > 0 && highestGstPct > 0) {
          const taxOnCharges = (chargesTotal * highestGstPct) / 100;
          if (igstTaxType) chargesIgst = taxOnCharges;
          else {
            chargesCgst = taxOnCharges / 2;
            chargesSgst = taxOnCharges / 2;
          }
        }

        const formHsnSummary = buildHsnSummary(
          formRows,
          discountRowsApplied,
          chargeRowsApplied,
          g,
        );

        const finalSgst = igstTaxType
          ? 0
          : round2(formHsnSummary?.totals?.sgst || 0);
        const finalCgst = igstTaxType
          ? 0
          : round2(formHsnSummary?.totals?.cgst || 0);
        const finalIgst = igstTaxType
          ? round2(formHsnSummary?.totals?.igst || 0)
          : 0;

        const gross = round2(formHsnSummary?.totals?.total || 0);
        const rounded = roundHalfUp(gross);
        const roundOff = round2(rounded - gross);

        const orderItems = formRows.map((r) => ({
          igstTaxType,
          productId: r.productId,
          productData: r.productData,
          discountPercentage: r.disCountPercentage,
          availableQty: r.availableQty,
          qty: Number(r.qty || 0),
          price: Number(r.price || 0),
          totalPrice: Number(r.qty || 0) * Number(r.price || 0),
          primaryUnit: r.primaryUnit,
          basicPrice: Number(r.basicPrice || 0),
          landedCost: r.landedCost,
          secondaryUnit: r.secondaryUnit,
          secondarySize: r.secondarySize,
          sgstRate: r.sgstRate,
          cgstRate: r.cgstRate,
          gstPercentage: r.gstPercentage,
          igstRate: r.igstRate,
          grandTotal: r.grandTotal,
          taxableAmount: r.taxableAmount,
          totalPriceWithDiscount: r.grandTotal,
        }));

        const discountDetails = [
          ...discountRowsApplied.map((x) => ({
            ...x,
            appliedAmount: x.__applied,
          })),
          ...chargeRowsApplied.map((x) => ({
            ...x,
            appliedAmount: x.__applied,
          })),
        ];

        const hsnPayload = {
          isIGST: !!formHsnSummary?.isIGST,
          rows: formHsnSummary?.rows || [],
          totals: formHsnSummary?.totals || {},
        };

        payloads.push({
          ...formExtra,

          userId: user?._id,
          database: selectedDatabase,
          financialYear: getFinancialYearLabel(formOrderDate),
          partyId: formPartyId,
          SuperAdmin: Context?.CompanyDetails?.created_by,
          fullName: formParty?.CompanyName,
          address: formParty?.address,

          invoiceId: purchaseOrderNumber,
          invoice: purchaseOrderNumber,
          poNumber: purchaseOrderNumber,
          purchaseOrderNo: purchaseOrderNumber,
          orderNumber: purchaseOrderNumber,

          amount: round2(formHsnSummary?.totals?.taxable || 0),
          ChargesCgst: Number(chargesCgst.toFixed(2)),
          ChargesSgst: Number(chargesSgst.toFixed(2)),
          ChargesIgst: Number(chargesIgst.toFixed(2)),
          sgstTotal: Number(finalSgst.toFixed(2)),
          cgstTotal: Number(finalCgst.toFixed(2)),
          igstTotal: Number(finalIgst.toFixed(2)),
          roundOff: Number(roundOff.toFixed(2)),
          grandTotal: Number(rounded.toFixed(2)),

          igstTaxType,
          gstDetails: g?.gstDetails,

          MobileNo: formParty?.contactNumber,
          state: formParty?.State,
          city: formParty?.City,
          orderItems,
          DateofDelivery: "",
          date: formOrderDate,

          coolieAndCartage: formCharges,
          transportationCost: formLanded?.transportationCost,
          labourCost: formLanded?.LabourCost,
          localFreight: formLanded?.LocalFreight,
          miscellaneousCost: formLanded?.MiscellanousCost,
          tax: formLanded?.landedTax,
          status: "completed",
          maxGstPercentage: Number(g?.Tax?.maxGst || 0),

          discountDetails,
          hsnSummary: hsnPayload,
        });
      }

      for (const payload of payloads) {
        await _PostSave(Purchase_Direct_Complete_Main, payload);
      }

      clearDraft();
      swal(
        payloads.length > 1
          ? `${payloads.length} Purchase Orders Completed`
          : "Purchase Order Completed",
      );
      navigate(-1);
    } catch (err) {
      console.error("CREATE COMPLETED PURCHASE ORDER ERROR:", err);
      swal(
        "Error",
        err?.response?.data?.message || err?.message || "Something Went Wrong",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cpi">
      <Card style={{ overflow: "visible" }}>
        <div className="headbar m-2">
          <h1>Create Purchase Order</h1>
          <Button color="danger" onClick={() => navigate(-1)}>
            Back
          </Button>
        </div>

        <CardBody style={{ overflow: "visible" }}>
          <div>
            {invoiceForms.map((formData, formIndex) => (
              <Card
                key={`purchase-invoice-form-${formIndex}`}
                className="batch-invoice-card"
                style={{ overflow: "visible" }}
              >
                <div
                  className={`batch-card-header ${
                    activeFormIndex === formIndex ? "active" : ""
                  }`}
                  onClick={() => switchInvoiceForm(formIndex)}
                >
                  <div>
                    <div className="batch-card-title">
                      Purchase Invoice {formIndex + 1}
                    </div>
                    <div className="batch-card-subtitle">
                      {formData?.extra?.invoiceId
                        ? `Invoice No: ${formData.extra.invoiceId}`
                        : "Invoice number not entered"}
                      {formData?.party?.CompanyName
                        ? ` • ${formData.party.CompanyName}`
                        : ""}
                    </div>
                  </div>

                  <div className="batch-card-actions">
                    {invoiceForms.length > 1 && (
                      <Button
                        type="button"
                        color="danger"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          removeInvoiceForm(formIndex);
                        }}
                      >
                        Remove
                      </Button>
                    )}
                    <span style={{ fontSize: 14 }}>
                      {activeFormIndex === formIndex ? "▲" : "▼"}
                    </span>
                  </div>
                </div>

                {activeFormIndex === formIndex && (
                  <CardBody
                    className="batch-card-body"
                    style={{ overflow: "visible" }}
                  >
                    <Form onSubmit={(e) => e.preventDefault()}>
                      {!partyLogin && (
                        <div
                          className="top-controls mb-2"
                          style={{
                            overflow: "visible",
                            position: "relative",
                            zIndex: 20,
                          }}
                        >
                          <div
                            className="box"
                            style={{
                              overflow: "visible",
                              position: "relative",
                              zIndex: 30,
                            }}
                          >
                            <Label>
                              Choose Party{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                              {partyId && (
                                <Link
                                  target="_blank"
                                  to={`/app/SoftNumen/account/CreateCustomer/${partyId}`}
                                  title="Edit Selected Party"
                                >
                                  ✎
                                </Link>
                              )}
                            </Label>
                            <div style={{ position: "relative", zIndex: 40 }}>
                              <Multiselect
                                selectionLimit={1}
                                isObject={true}
                                options={partyList}
                                selectedValues={partyId ? [party] : []}
                                onSelect={handleSelectParty}
                                onRemove={handleRemoveParty}
                                displayValue="CompanyName"
                                avoidHighlightFirstOption={true}
                                hidePlaceholder={false}
                                style={{
                                  multiselectContainer: {
                                    overflow: "visible",
                                    background: "#fff",
                                  },
                                  searchBox: {
                                    minHeight: "30px",
                                    borderRadius: "8px",
                                    background: "#fff",
                                  },
                                  chips: {
                                    fontSize: "11px",
                                    background: "#eef2ff",
                                    color: "#111827",
                                  },
                                  optionContainer: {
                                    zIndex: 99999,
                                    position: "absolute",
                                    minWidth: "100%",
                                    background: "#fff",
                                    color: "#111827",
                                    border: "1px solid #d1d5db",
                                    boxShadow: "0 14px 28px rgba(0,0,0,0.16)",
                                  },
                                  option: {
                                    background: "#fff",
                                    color: "#111827",
                                  },
                                }}
                              />
                            </div>
                          </div>

                          <div className="box" style={{ minWidth: 160 }}>
                            <Label>
                              Invoice Date{" "}
                              <span style={{ color: "red" }}>*</span>
                            </Label>
                            <Input
                              required
                              type="date"
                              min={financialYearRange.minDate}
                              max={financialYearRange.maxDate}
                              value={orderDate}
                              onChange={(e) => setOrderDate(e.target.value)}
                            />
                          </div>

                          <div className="box" style={{ minWidth: 160 }}>
                            <Label>Coolie & Cartage</Label>
                            <Input
                              type="number"
                              min={0}
                              step="0.01"
                              value={charges}
                              onChange={handleCharges}
                              placeholder="Charges"
                            />
                          </div>
                        </div>
                      )}

                      {rows.map((r, idx) => (
                        <div
                          key={idx}
                          className="prod-row mb-2"
                          style={{
                            overflow: "visible",
                            position: "relative",
                            zIndex: rows.length - idx,
                          }}
                        >
                          <div
                            className="box prod-select"
                            style={{
                              overflow: "visible",
                              position: "relative",
                              zIndex: 100 + (rows.length - idx),
                            }}
                          >
                            <Label>
                              Choose Product{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                              {r.productId && (
                                <Link
                                  target="_blank"
                                  to={`/app/freshlist/house/EditAddProduct/${r.productId}`}
                                  title="Edit Selected Product"
                                  style={{ marginLeft: 6 }}
                                >
                                  ✎
                                </Link>
                              )}
                            </Label>

                            <div
                              style={{
                                position: "relative",
                                zIndex: 200 + (rows.length - idx),
                                overflow: "visible",
                              }}
                            >
                              <Multiselect
                                ref={multiselectRefs.current[idx]}
                                selectionLimit={1}
                                isObject={true}
                                options={productList}
                                selectedValues={
                                  r.productId && r.productData
                                    ? [r.productData]
                                    : []
                                }
                                onSelect={(list, item) =>
                                  handleSelectProduct(list, item, idx)
                                }
                                onRemove={(list, item) =>
                                  handleRemoveProduct(list, item, idx)
                                }
                                displayValue="Product_Title"
                                avoidHighlightFirstOption={true}
                                hidePlaceholder={false}
                                style={{
                                  multiselectContainer: {
                                    overflow: "visible",
                                    background: "#fff",
                                  },
                                  searchBox: {
                                    minHeight: "30px",
                                    borderRadius: "8px",
                                    background: "#fff",
                                  },
                                  chips: {
                                    fontSize: "11px",
                                    background: "#eef2ff",
                                    color: "#111827",
                                  },
                                  optionContainer: {
                                    zIndex: 99999,
                                    position: "absolute",
                                    minWidth: "240px",
                                    maxHeight: "260px",
                                    background: "#fff",
                                    color: "#111827",
                                    border: "1px solid #d1d5db",
                                    boxShadow: "0 14px 28px rgba(0,0,0,0.16)",
                                  },
                                  option: {
                                    background: "#fff",
                                    color: "#111827",
                                  },
                                }}
                              />
                            </div>
                          </div>

                          <div className="box w-ware">
                            <Label>Warehouse</Label>
                            <Input readOnly value={r.warehouseName || ""} />
                          </div>

                          <div className="box w-hsn">
                            <Label>HSN</Label>
                            <Input readOnly value={r.HSN_Code || ""} />
                          </div>

                          <div className="box w-gunit">
                            <Label>Gross Unit</Label>
                            <Input readOnly value={r.secondaryUnit || ""} />
                          </div>

                          <div className="box w-gqty">
                            <Label>Gross Qty</Label>
                            <Input
                              type="number"
                              step="0.001"
                              name="GrossQty"
                              value={r.GrossQty}
                              onChange={(e) => handleQtyChange(e, idx)}
                            />
                          </div>

                          <div className="box w-nqty">
                            <Label>Net Qty</Label>
                            <Input
                              type="number"
                              step="0.001"
                              name="qty"
                              min={0}
                              value={r.qty}
                              onChange={(e) => handleQtyChange(e, idx)}
                            />
                          </div>

                          <div className="box w-nunit">
                            <Label>Net Unit</Label>
                            <Input readOnly value={r.primaryUnit || ""} />
                          </div>

                          <div className="box w-tax">
                            <Label>Tax %</Label>
                            <Input readOnly value={r.gstPercentage} />
                          </div>

                          <div className="box w-bprice">
                            <Label>Basic Price</Label>
                            <Input
                              type="number"
                              step="0.01"
                              value={r.basicPrice}
                              onChange={(e) => handlePriceChange(e, idx)}
                            />
                          </div>

                          <div className="box w-btotal">
                            <Label>Basic Total</Label>
                            <Input
                              type="number"
                              step="0.01"
                              value={
                                r.taxableAmount !== "" &&
                                r.taxableAmount !== null &&
                                r.taxableAmount !== undefined
                                  ? r.taxableAmount
                                  : Number(
                                      (
                                        Number(r.qty || 0) *
                                        Number(r.basicPrice || 0)
                                      ).toFixed(2),
                                    )
                              }
                              onChange={(e) => handleBasicTotalChange(e, idx)}
                              onBlur={() => {
                                setRows((prev) => {
                                  const next = [...prev];
                                  const row = { ...next[idx] };
                                  const qty = Number(row.qty || 0);
                                  const basicPrice = Number(
                                    row.basicPrice || 0,
                                  );

                                  row.taxableAmount = Number(
                                    (qty * basicPrice).toFixed(2),
                                  );
                                  next[idx] = row;

                                  const g = recalcGST(party, next, charges);
                                  const gi = g?.gstDetails?.[idx] || {};
                                  next[idx] = {
                                    ...next[idx],
                                    taxableAmount: row.taxableAmount,
                                    sgstRate: gi.sgstRate ?? 0,
                                    cgstRate: gi.cgstRate ?? 0,
                                    igstRate: gi.igstRate ?? 0,
                                    grandTotal: gi.grandTotal ?? 0,
                                    gstPercentage:
                                      gi.gstPercentage ??
                                      next[idx].gstPercentage,
                                    disCountPercentage:
                                      gi.discountPercentage ??
                                      next[idx].disCountPercentage,
                                  };

                                  recalcTotals(
                                    next,
                                    selectedDiscountRows,
                                    selectedChargesRows,
                                    party,
                                    g,
                                  );
                                  return next;
                                });
                              }}
                            />
                          </div>

                          <div className="box w-del">
                            {idx > 0 && (
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => removeRow(idx)}
                                style={{ marginTop: 22 }}
                              >
                                ✕
                              </Button>
                            )}
                          </div>
                        </div>
                      ))}

                      <div className="d-flex justify-content-end mb-2">
                        <Button color="primary" size="sm" onClick={addRow}>
                          + Add
                        </Button>
                      </div>

                      <div className="meta-adjust">
                        <div className="meta-left">
                          <div className="meta-grid">
                            <div className="box">
                              <Label>Invoice Number</Label>
                              <Input
                                required
                                name="invoiceId"
                                value={extra?.invoiceId || ""}
                                onChange={(e) =>
                                  setExtra({
                                    ...extra,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                                placeholder="Invoice Id"
                              />
                            </div>

                            <div className="box">
                              <Label>Builty Number</Label>
                              <Input
                                required
                                name="BuiltyNumber"
                                value={extra?.BuiltyNumber || ""}
                                onChange={(e) =>
                                  setExtra({
                                    ...extra,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                                placeholder="Builty No."
                              />
                            </div>

                            <div className="box">
                              <Label>Dispatch Date</Label>
                              <Input
                                required
                                type="date"
                                name="DispatchDate"
                                min={financialYearRange.minDate}
                                max={financialYearRange.maxDate}
                                value={extra?.DispatchDate || ""}
                                onChange={(e) =>
                                  setExtra({
                                    ...extra,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                              />
                            </div>

                            <div className="box">
                              <Label>No of Packages</Label>
                              <Input
                                required
                                type="number"
                                name="NoOfPackage"
                                value={extra?.NoOfPackage || ""}
                                onChange={(e) =>
                                  setExtra({
                                    ...extra,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                                placeholder="Packages"
                              />
                            </div>

                            <div className="box">
                              <Label>Transporter</Label>
                              <Input
                                type="select"
                                name="transporterId"
                                value={extra?.transporterId || ""}
                                onChange={(e) => {
                                  const id = e.target.value;
                                  const picked = (
                                    party?.assignTransporter || []
                                  ).find((t) => t?._id?._id === id);
                                  setExtra({
                                    ...extra,
                                    transporterId: id,
                                    transporter: picked,
                                  });
                                }}
                              >
                                <option value="">----Select----</option>
                                {(party?.assignTransporter || []).map(
                                  (t, i) => (
                                    <option key={i} value={t?._id?._id}>
                                      {t?.companyName}
                                    </option>
                                  ),
                                )}
                              </Input>
                            </div>

                            <div className="box">
                              <Label>Vehicle Number</Label>
                              <Input
                                required
                                name="vehicleNo"
                                value={extra?.vehicleNo || ""}
                                onChange={(e) =>
                                  setExtra({
                                    ...extra,
                                    [e.target.name]: e.target.value,
                                  })
                                }
                                placeholder="Vehicle No."
                              />
                            </div>
                          </div>

                          <div className="adjust-hsn-left">
                            <h5 style={{ marginBottom: 6 }}>
                              Bill Adjustments
                            </h5>

                            <div
                              className="d-flex align-items-end"
                              style={{ gap: 8 }}
                            >
                              <div style={{ minWidth: 260 }}>
                                <Label>Add Discount / Charge</Label>
                                <Input
                                  type="select"
                                  onChange={(e) => {
                                    const id = e.target.value;
                                    if (!id) return;
                                    e.target.value = "";
                                    const master = chargesMaster.find(
                                      (x) => x._id === id,
                                    );
                                    if (!master) return;

                                    const rowData = {
                                      id: master._id,
                                      title: master.title,
                                      type: master.type,
                                      discounttype: master.discounttype,
                                      percentage: master.percentage || "",
                                      amount: master.amount || "",
                                      __applied: 0,
                                    };

                                    if (
                                      (master.type || "")
                                        .toLowerCase()
                                        .includes("discount")
                                    ) {
                                      const arr = [
                                        ...selectedDiscountRows,
                                        rowData,
                                      ];
                                      setSelectedDiscountRows(arr);
                                      recalcTotals(
                                        rows,
                                        arr,
                                        selectedChargesRows,
                                        party,
                                      );
                                    } else {
                                      const arr = [
                                        ...selectedChargesRows,
                                        rowData,
                                      ];
                                      setSelectedChargesRows(arr);
                                      recalcTotals(
                                        rows,
                                        selectedDiscountRows,
                                        arr,
                                        party,
                                      );
                                    }
                                  }}
                                >
                                  <option value="">
                                    -- Select from master --
                                  </option>
                                  {chargesMaster.map((x) => (
                                    <option key={x._id} value={x._id}>
                                      {x.title} ({x.type})
                                    </option>
                                  ))}
                                </Input>
                              </div>

                              <Button
                                color="success"
                                size="sm"
                                onClick={() =>
                                  setSelectedDiscountRows((prev) => [
                                    ...prev,
                                    {
                                      id: "",
                                      title: "",
                                      type: "Discount",
                                      discounttype: "",
                                      percentage: "",
                                      amount: "",
                                      __applied: 0,
                                    },
                                  ])
                                }
                              >
                                + Discount
                              </Button>

                              <Button
                                color="primary"
                                size="sm"
                                onClick={() =>
                                  setSelectedChargesRows((prev) => [
                                    ...prev,
                                    {
                                      id: "",
                                      title: "",
                                      type: "Charges",
                                      discounttype: "",
                                      percentage: "",
                                      amount: "",
                                      __applied: 0,
                                    },
                                  ])
                                }
                              >
                                + Charge
                              </Button>
                            </div>

                            <div className="adj-head mt-2">
                              <div>#</div>
                              <div>Type</div>
                              <div>Title / Master</div>
                              <div>Method</div>
                              <div>%</div>
                              <div>Amount</div>
                              <div>Applied</div>
                              <div>Action</div>
                            </div>

                            {selectedDiscountRows.map((r, i) => {
                              const isPct =
                                (r.discounttype || "").toLowerCase() ===
                                "percentage";
                              return (
                                <div className="adj-row mb-1" key={`disc-${i}`}>
                                  <div>{i + 1}</div>
                                  <div>Discount</div>

                                  <div>
                                    <Input
                                      type="select"
                                      value={r.id || ""}
                                      onChange={(e) => {
                                        const master = chargesMaster.find(
                                          (m) => m._id === e.target.value,
                                        );
                                        if (!master) return;
                                        const arr = [...selectedDiscountRows];
                                        arr[i] = {
                                          id: master._id,
                                          title: master.title,
                                          type: master.type,
                                          discounttype: master.discounttype,
                                          percentage: master.percentage || "",
                                          amount: master.amount || "",
                                          __applied: 0,
                                        };
                                        setSelectedDiscountRows(arr);
                                        recalcTotals(
                                          rows,
                                          arr,
                                          selectedChargesRows,
                                          party,
                                        );
                                      }}
                                    >
                                      <option value="">-- Select --</option>
                                      {chargesMaster
                                        .filter((m) =>
                                          (m.type || "")
                                            .toLowerCase()
                                            .includes("discount"),
                                        )
                                        .map((m) => (
                                          <option key={m._id} value={m._id}>
                                            {m.title}
                                          </option>
                                        ))}
                                    </Input>
                                  </div>

                                  <div>
                                    <Input
                                      type="select"
                                      value={r.discounttype || ""}
                                      onChange={(e) => {
                                        const arr = [...selectedDiscountRows];
                                        arr[i] = {
                                          ...arr[i],
                                          discounttype: e.target.value,
                                        };
                                        setSelectedDiscountRows(arr);
                                        recalcTotals(
                                          rows,
                                          arr,
                                          selectedChargesRows,
                                          party,
                                        );
                                      }}
                                    >
                                      <option value="">Choose</option>
                                      <option value="Percentage">
                                        Percentage
                                      </option>
                                      <option value="Amount">Amount</option>
                                    </Input>
                                  </div>

                                  <div>
                                    <Input
                                      type="number"
                                      inputMode="decimal"
                                      step="0.01"
                                      placeholder="%"
                                      disabled={!isPct}
                                      value={
                                        r.percentage === "" ? "" : r.percentage
                                      }
                                      onChange={(e) => {
                                        const arr = [...selectedDiscountRows];
                                        arr[i] = {
                                          ...arr[i],
                                          percentage:
                                            e.target.value === ""
                                              ? ""
                                              : Number(e.target.value) || "",
                                        };
                                        setSelectedDiscountRows(arr);
                                        recalcTotals(
                                          rows,
                                          arr,
                                          selectedChargesRows,
                                          party,
                                        );
                                      }}
                                    />
                                  </div>

                                  <div>
                                    <Input
                                      type="number"
                                      inputMode="decimal"
                                      step="0.01"
                                      placeholder="₹"
                                      disabled={isPct}
                                      value={r.amount === "" ? "" : r.amount}
                                      onChange={(e) => {
                                        const arr = [...selectedDiscountRows];
                                        arr[i] = {
                                          ...arr[i],
                                          amount:
                                            e.target.value === ""
                                              ? ""
                                              : Number(e.target.value) || "",
                                        };
                                        setSelectedDiscountRows(arr);
                                        recalcTotals(
                                          rows,
                                          arr,
                                          selectedChargesRows,
                                          party,
                                        );
                                      }}
                                    />
                                  </div>

                                  <div>
                                    <Input readOnly value={r.__applied ?? 0} />
                                  </div>

                                  <div>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() => {
                                        const arr = [...selectedDiscountRows];
                                        arr.splice(i, 1);
                                        setSelectedDiscountRows(arr);
                                        recalcTotals(
                                          rows,
                                          arr,
                                          selectedChargesRows,
                                          party,
                                        );
                                      }}
                                    >
                                      🗑
                                    </Button>
                                  </div>
                                </div>
                              );
                            })}

                            {selectedChargesRows.map((r, i) => {
                              const isPct =
                                (r.discounttype || "").toLowerCase() ===
                                "percentage";
                              return (
                                <div
                                  className="adj-row mb-1"
                                  key={`charge-${i}`}
                                >
                                  <div>{i + 1}</div>
                                  <div>Charge</div>

                                  <div>
                                    <Input
                                      type="select"
                                      value={r.id || ""}
                                      onChange={(e) => {
                                        const master = chargesMaster.find(
                                          (m) => m._id === e.target.value,
                                        );
                                        if (!master) return;
                                        const arr = [...selectedChargesRows];
                                        arr[i] = {
                                          id: master._id,
                                          title: master.title,
                                          type: master.type,
                                          discounttype: master.discounttype,
                                          percentage: master.percentage || "",
                                          amount: master.amount || "",
                                          __applied: 0,
                                        };
                                        setSelectedChargesRows(arr);
                                        recalcTotals(
                                          rows,
                                          selectedDiscountRows,
                                          arr,
                                          party,
                                        );
                                      }}
                                    >
                                      <option value="">-- Select --</option>
                                      {chargesMaster
                                        .filter((m) =>
                                          (m.type || "")
                                            .toLowerCase()
                                            .includes("charge"),
                                        )
                                        .map((m) => (
                                          <option key={m._id} value={m._id}>
                                            {m.title}
                                          </option>
                                        ))}
                                    </Input>
                                  </div>

                                  <div>
                                    <Input
                                      type="select"
                                      value={r.discounttype || ""}
                                      onChange={(e) => {
                                        const arr = [...selectedChargesRows];
                                        arr[i] = {
                                          ...arr[i],
                                          discounttype: e.target.value,
                                        };
                                        setSelectedChargesRows(arr);
                                        recalcTotals(
                                          rows,
                                          selectedDiscountRows,
                                          arr,
                                          party,
                                        );
                                      }}
                                    >
                                      <option value="">Choose</option>
                                      <option value="Percentage">
                                        Percentage
                                      </option>
                                      <option value="Amount">Amount</option>
                                    </Input>
                                  </div>

                                  <div>
                                    <Input
                                      type="number"
                                      inputMode="decimal"
                                      step="0.01"
                                      placeholder="%"
                                      disabled={!isPct}
                                      value={
                                        r.percentage === "" ? "" : r.percentage
                                      }
                                      onChange={(e) => {
                                        const arr = [...selectedChargesRows];
                                        arr[i] = {
                                          ...arr[i],
                                          percentage:
                                            e.target.value === ""
                                              ? ""
                                              : Number(e.target.value) || "",
                                        };
                                        setSelectedChargesRows(arr);
                                        recalcTotals(
                                          rows,
                                          selectedDiscountRows,
                                          arr,
                                          party,
                                        );
                                      }}
                                    />
                                  </div>

                                  <div>
                                    <Input
                                      type="number"
                                      inputMode="decimal"
                                      step="0.01"
                                      placeholder="₹"
                                      disabled={isPct}
                                      value={r.amount === "" ? "" : r.amount}
                                      onChange={(e) => {
                                        const arr = [...selectedChargesRows];
                                        arr[i] = {
                                          ...arr[i],
                                          amount:
                                            e.target.value === ""
                                              ? ""
                                              : Number(e.target.value) || "",
                                        };
                                        setSelectedChargesRows(arr);
                                        recalcTotals(
                                          rows,
                                          selectedDiscountRows,
                                          arr,
                                          party,
                                        );
                                      }}
                                    />
                                  </div>

                                  <div>
                                    <Input readOnly value={r.__applied ?? 0} />
                                  </div>

                                  <div>
                                    <Button
                                      color="danger"
                                      size="sm"
                                      onClick={() => {
                                        const arr = [...selectedChargesRows];
                                        arr.splice(i, 1);
                                        setSelectedChargesRows(arr);
                                        recalcTotals(
                                          rows,
                                          selectedDiscountRows,
                                          arr,
                                          party,
                                        );
                                      }}
                                    >
                                      🗑
                                    </Button>
                                  </div>
                                </div>
                              );
                            })}

                            {hsnSummary.rows.length > 0 && (
                              <div className="hsn-wrap">
                                <h6 style={{ marginBottom: 4 }}>HSN Summary</h6>
                                <Table bordered size="sm">
                                  <thead>
                                    <tr>
                                      <th>HSN/SAC</th>
                                      <th className="text-end">Taxable</th>
                                      <th className="text-center">Rate</th>
                                      {!hsnSummary.isIGST && (
                                        <th className="text-end">CGST</th>
                                      )}
                                      {!hsnSummary.isIGST && (
                                        <th className="text-end">SGST</th>
                                      )}
                                      {hsnSummary.isIGST && (
                                        <th className="text-end">IGST</th>
                                      )}
                                      <th className="text-end">Total</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {hsnSummary.rows.map((r, i) => (
                                      <tr key={`hsn-${r.hsn}-${i}`}>
                                        <td>{r.hsn}</td>
                                        <td className="text-end">
                                          {r.taxable.toFixed(2)}
                                        </td>
                                        <td className="text-center">{`${r.ratePct}%`}</td>
                                        {!hsnSummary.isIGST && (
                                          <td className="text-end">
                                            {(r.cgst || 0).toFixed(2)}
                                          </td>
                                        )}
                                        {!hsnSummary.isIGST && (
                                          <td className="text-end">
                                            {(r.sgst || 0).toFixed(2)}
                                          </td>
                                        )}
                                        {hsnSummary.isIGST && (
                                          <td className="text-end">
                                            {(r.igst || 0).toFixed(2)}
                                          </td>
                                        )}
                                        <td className="text-end">
                                          {r.total.toFixed(2)}
                                        </td>
                                      </tr>
                                    ))}

                                    <tr>
                                      <td className="fw-bold">TOTAL</td>
                                      <td className="text-end fw-bold">
                                        {round2(
                                          hsnSummary.totals.taxable,
                                        ).toFixed(2)}
                                      </td>
                                      <td />
                                      {!hsnSummary.isIGST && (
                                        <td className="text-end fw-bold">
                                          {round2(
                                            hsnSummary.totals.cgst,
                                          ).toFixed(2)}
                                        </td>
                                      )}
                                      {!hsnSummary.isIGST && (
                                        <td className="text-end fw-bold">
                                          {round2(
                                            hsnSummary.totals.sgst,
                                          ).toFixed(2)}
                                        </td>
                                      )}
                                      {hsnSummary.isIGST && (
                                        <td className="text-end fw-bold">
                                          {round2(
                                            hsnSummary.totals.igst,
                                          ).toFixed(2)}
                                        </td>
                                      )}
                                      <td className="text-end fw-bold">
                                        {round2(
                                          hsnSummary.totals.total,
                                        ).toFixed(2)}
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="bill-summary-only">
                          <div className="jt-right-summary">
                            <h6 style={{ marginBottom: 6 }}>
                              Summary (with Bill Adjustments)
                            </h6>
                            <ul>
                              <li>
                                <span>Basic Total</span>
                                <strong>
                                  {Number(sumLineBasics(rows)).toFixed(2)}
                                </strong>
                              </li>

                              <li>
                                <span>Discount Total</span>
                                <strong>
                                  {selectedDiscountRows
                                    .reduce(
                                      (a, r) => a + (Number(r.__applied) || 0),
                                      0,
                                    )
                                    .toFixed(2)}
                                </strong>
                              </li>

                              <li>
                                <span>Charges Total</span>
                                <strong>
                                  {selectedChargesRows
                                    .reduce(
                                      (a, r) => a + (Number(r.__applied) || 0),
                                      0,
                                    )
                                    .toFixed(2)}
                                </strong>
                              </li>

                              <li>
                                <span>Taxable Value</span>
                                <strong>
                                  {summaryFromHSN.taxable.toFixed(2)}
                                </strong>
                              </li>

                              {billTaxSummary.isIGST ? (
                                <>
                                  <li>
                                    <span>IGST (incl. on charges)</span>
                                    <strong
                                      style={
                                        Math.abs(taxMismatch.igst) > 0.01
                                          ? { color: "red" }
                                          : undefined
                                      }
                                    >
                                      {summaryFromHSN.igst.toFixed(2)}
                                    </strong>
                                  </li>

                                  {Math.abs(taxMismatch.igst) > 0.01 && (
                                    <li>
                                      <span
                                        style={{
                                          color: "red",
                                          fontWeight: 700,
                                        }}
                                      >
                                        IGST Difference
                                      </span>
                                      <strong style={{ color: "red" }}>
                                        {taxMismatch.igst > 0 ? "+" : ""}
                                        {taxMismatch.igst.toFixed(2)}
                                      </strong>
                                    </li>
                                  )}
                                </>
                              ) : (
                                <>
                                  <li>
                                    <span>SGST (incl. on charges)</span>
                                    <strong
                                      style={
                                        Math.abs(taxMismatch.sgst) > 0.01
                                          ? { color: "red" }
                                          : undefined
                                      }
                                    >
                                      {summaryFromHSN.sgst.toFixed(2)}
                                    </strong>
                                  </li>

                                  {Math.abs(taxMismatch.sgst) > 0.01 && (
                                    <li>
                                      <span
                                        style={{
                                          color: "red",
                                          fontWeight: 700,
                                        }}
                                      >
                                        SGST Difference
                                      </span>
                                      <strong style={{ color: "red" }}>
                                        {taxMismatch.sgst > 0 ? "+" : ""}
                                        {taxMismatch.sgst.toFixed(2)}
                                      </strong>
                                    </li>
                                  )}

                                  <li>
                                    <span>CGST (incl. on charges)</span>
                                    <strong
                                      style={
                                        Math.abs(taxMismatch.cgst) > 0.01
                                          ? { color: "red" }
                                          : undefined
                                      }
                                    >
                                      {summaryFromHSN.cgst.toFixed(2)}
                                    </strong>
                                  </li>

                                  {Math.abs(taxMismatch.cgst) > 0.01 && (
                                    <li>
                                      <span
                                        style={{
                                          color: "red",
                                          fontWeight: 700,
                                        }}
                                      >
                                        CGST Difference
                                      </span>
                                      <strong style={{ color: "red" }}>
                                        {taxMismatch.cgst > 0 ? "+" : ""}
                                        {taxMismatch.cgst.toFixed(2)}
                                      </strong>
                                    </li>
                                  )}
                                </>
                              )}

                              <li>
                                <span>RoundOff</span>
                                <strong>{summaryRoundOff.toFixed(2)}</strong>
                              </li>

                              <hr className="hr" />

                              <li>
                                <span>Grand Total</span>
                                <strong
                                  style={
                                    grandTotalMismatch
                                      ? { color: "red" }
                                      : undefined
                                  }
                                >
                                  {Number(
                                    summaryRoundedGrandTotal || 0,
                                  ).toFixed(2)}
                                </strong>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div className="d-flex justify-content-center mt-2">
                        <Button
                          color="warning"
                          type="button"
                          onClick={openUpdateModal}
                        >
                          Update Landed Price
                        </Button>
                      </div>
                    </Form>
                  </CardBody>
                )}
              </Card>
            ))}

            <div className="d-flex justify-content-end mt-2" style={{ gap: 8 }}>
              <Button
                type="button"
                color="success"
                onClick={addMoreInvoiceForm}
                disabled={loading}
              >
                + Add More
              </Button>

              <Button
                type="button"
                color="primary"
                onClick={submitFinal}
                disabled={loading}
              >
                {loading ? "Submitting All..." : "Submit All"}
              </Button>
            </div>
          </div>
        </CardBody>
      </Card>

      <Modal size="lg" isOpen={modal} toggle={() => setModal(false)} {...args}>
        <ModalHeader toggle={() => setModal(false)}>
          Update Landed Price - Invoice {activeFormIndex + 1}
          {extra?.invoiceId ? ` (${extra.invoiceId})` : ""}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={(e) => e.preventDefault()}>
            <div className="d-flex justify-content-center p-1">
              <h5>Update Landed Price</h5>
            </div>

            <Row className="mt-1">
              <Col lg="4" md="6" sm="6" className="mb-1">
                <Label>Transportation Cost</Label>
                <Input
                  required
                  min={0}
                  type="number"
                  name="transportationCost"
                  value={landed?.transportationCost || 0}
                  onChange={handleLanded}
                />
              </Col>

              <Col lg="4" md="6" sm="6" className="mb-1">
                <Label>Labour Cost</Label>
                <Input
                  required
                  min={0}
                  type="number"
                  name="LabourCost"
                  value={landed?.LabourCost || 0}
                  onChange={handleLanded}
                />
              </Col>

              <Col lg="4" md="6" sm="6" className="mb-1">
                <Label>Local Freight</Label>
                <Input
                  required
                  min={0}
                  type="number"
                  name="LocalFreight"
                  value={landed?.LocalFreight || 0}
                  onChange={handleLanded}
                />
              </Col>

              <Col lg="4" md="6" sm="6" className="mb-1">
                <Label>Miscellaneous Cost</Label>
                <Input
                  required
                  min={0}
                  type="number"
                  name="MiscellanousCost"
                  value={landed?.MiscellanousCost || 0}
                  onChange={handleLanded}
                />
              </Col>

              <Col lg="4" md="6" sm="6" className="mb-1">
                <Label>Tax</Label>
                <Input
                  readOnly
                  type="number"
                  name="landedTax"
                  value={landed?.landedTax || 0}
                />
              </Col>
            </Row>

            <Row className="mt-1">
              <Col className="d-flex justify-content-end">
                <div style={{ width: 300 }}>
                  <div className="d-flex justify-content-between">
                    <h6>Sub-Total</h6>
                    <h6>
                      {(
                        (landed?.transportationCost || 0) +
                        (landed?.MiscellanousCost || 0) +
                        (landed?.LocalFreight || 0) +
                        (landed?.LabourCost || 0)
                      ).toFixed(2)}
                    </h6>
                  </div>

                  <div className="d-flex justify-content-between">
                    <h6>Tax</h6>
                    <h6>{Number(landed?.landedTax || 0).toFixed(2)}</h6>
                  </div>

                  <hr />

                  <div className="d-flex justify-content-between">
                    <h6>Total</h6>
                    <h6>
                      {(
                        (landed?.transportationCost || 0) +
                        (landed?.MiscellanousCost || 0) +
                        (landed?.LocalFreight || 0) +
                        (landed?.LabourCost || 0) +
                        (landed?.landedTax || 0)
                      ).toFixed(2)}
                    </h6>
                  </div>
                </div>
              </Col>
            </Row>

            <div
              className="d-flex justify-content-center mt-2"
              style={{ gap: 8 }}
            >
              <Button
                color="secondary"
                type="button"
                onClick={() => setModal(false)}
              >
                Cancel
              </Button>
              <Button
                color="primary"
                type="button"
                onClick={saveLandedPriceForCurrentInvoice}
              >
                Save Landed Price
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default CreatePurchaseInvoice;
